<template>
  <div class="col-12">
    <Search
      :title="$route.meta.label"
      :allowFields="$lang.womenInfluenceConfirmFields"
      :hiddenFields="hiddenFields"
      :url="url"
      :allowCollapse="false"
      :visibleSearch="true"
      :visibleSettings="true"
      :visibleExport="true"
      :visibleFilters="true"
      :visibleViewCount="true"
      :allowEdit="false"
      :filterCatch="true"
      :showTotals="true"
      :openNewTab="true"
      :visibleAdd="false"
      :allowOperate="false"
      :isConfirmedFn="handleIsConfirmedFn"
      removeModalSize="lg"
      :defaultViewCount="10"
      :showAlert="true"
      colorAlert="danger"
      :titleAlert="$lang.womenInfluenceConfirmMessage"
      :operationField="$lang.records"
      :dynamicButtons="dynamicButtons"
      @getPermisson="updatePermissions"
    />
    <b-modal v-model="designPdfPageModal" size="xl" hide-footer hide-header>
      <b-row>
        <b-col cols="12" class="text-right mt-3">
          <DesignPdfPage :personCode="personCode" />
        </b-col>
        <b-col cols="12" class="text-right mt-3">
          <b-button
            variant="outline-danger"
            @click="designPdfPageModal = false"
          >
            <mdicon name="close" size="24" />
            {{ $lang.close }}
          </b-button>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import Search from "@/components/base/search";
import DesignPdfPage from "@/modules/profile/views/pdfpage/DesignPdfPage.vue";
import { pathOr, includes } from "ramda";
import {
  isAdmin,
  generateApiUrl,
  goToRoute,
  generateError,
} from "@/shared/utils";
import { confirmWomenInfluence } from "@/modules/survey/services";

export default {
  components: {
    Search,
    DesignPdfPage,
  },
  data() {
    return {
      dynamicButtons: [
        {
          name: "editView",
          text: this.$lang.person_info_pdf,
          AllowPermissions: ["admin", "edit", "view"],
          iconFont: {
            name: "account-details-outline",
            size: "24",
            class: "text-primary",
          },
          click: this.goToPdfPerson,
        },
      ],
      parentPermissions: [],
      hiddenFields: ["created_by", "created_at.jalali"],
      designPdfPageModal: false,
      personCode: null,
    };
  },
  computed: {
    url() {
      return generateApiUrl(["survey", "womenInfluenceConfirm"]);
    },
  },
  methods: {
    pathOr,
    includes,
    isAdmin,
    generateApiUrl,
    goToRoute,
    getData() {
      this.$refs.survey.getItems();
    },
    updatePermissions(permissions) {
      this.parentPermissions = [...permissions];
    },
    goToPdfPerson(item) {
      this.personCode = pathOr(null, ["person", "code"], item);
      this.designPdfPageModal = true;
    },
    async handleIsConfirmedFn(item) {
      // eslint-disable-next-line no-useless-catch
      try {
        const parvandehCode = pathOr(null, ["parvandeh_code"], item);
        await confirmWomenInfluence(parvandehCode);
      } catch (error) {
        throw error;
      }
    },
  },
};
</script>
